export default "__VITE_ASSET__CTQh$EH8__"